export const Hobbies = axios => ({
  get(slug) {
    return axios.get(`/v1/profiles/${slug}/hobbies`)
  },
  update(slug, payload) {
    return axios.put(`/v1/profiles/${slug}/hobbies`, { hobbies: payload })
  }
})
